// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactNavButton-cls1__baadbc38f342507c71ad","cls2":"ImpactNavButton-cls2__d87502e9d75d49334474 ImpactNavButton-cls1__baadbc38f342507c71ad"};